import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import CompanyData from "./CompanyModel/CompanyData"

export default function CompaniesGetObservable(name: string, showInactive: boolean = false): Observable<CompanyData[]> {
  const requestBody: string = JSON.stringify({ ClientName: name, IsActivateClient: showInactive })

  return ObservableFromFetch<CompanyData[]>("FFOrderClientFileMaintenance/GetClientInformation", requestBody)
}

export function CompaniesDetailsExportCsv() {
  return ObservableFromFetch<string>("FFOrderClinicFileMaintenance/ExportCompaniesDetails")
}

